import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import { HSeparator } from "components/admin/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustrationDoc from "assets/img/auth/image.png";
import illustration from 'assets/img/auth/auth.png';

import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import Api from "config/api";
import { useDispatch } from "react-redux";
import { Login } from "./../../../redux/slices/logedUserSlice";
import { notifyError } from "./../../../utils/Toastify";
import { notifySuccess } from './../../../utils/Toastify';

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue('#3B8F4F', 'white');
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const googleBg = useColorModeValue("secondaryGray.300", "whiteAlpha.200");
  const googleText = useColorModeValue("navy.700", "white");
  const googleHover = useColorModeValue(
    { bg: "gray.200" },
    { bg: "whiteAlpha.300" }
  );
  const googleActive = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.200" }
  );
  const dispatch=useDispatch()
  const [show, setShow] = React.useState(false);
  const navigate=useNavigate()
  const handleClick = () => setShow(!show);
const handleSubmit=async(e)=>{
      e.preventDefault();
      const formData = new FormData(e.target);
      const username = formData.get('username');
      const password = formData.get('password');
      try{
        
        const data = await Api.post('/auth/login', { username, password });
        dispatch(Login(data.data))
        console.log("🚀 ~ handleSubmit ~ data:", data)
        console.log('data.data', data.data);
        notifySuccess("Login successful")
        navigate('/admin/default');
        e.target.reset();
      }catch(e){
        console.log("🚀 ~ handleSubmit ~ e:", e)
        let message=e.response?.data?.message || e?.response?.data?.message[0] 
        notifyError(message)
      }



}
  return (
    <DefaultAuth
      illustrationBackground={illustrationDoc}
      image={illustrationDoc}
    >
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: '30px', md: '60px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '40px', md: '14vh' }}
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="50px" mb="10px">
            Welcome back !
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
            maxW="400px"
          >
            sign in to your account to manage your health and services and
            appointments effectivily
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: '100%', md: '420px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
        >
          <form onSubmit={handleSubmit}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Username<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: '0px', md: '0px' }}
                type="text"
                placeholder="abdelrahman"
                mb="24px"
                fontWeight="500"
                size="lg"
                name="username"
              />
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                display="flex"
              >
                Password<Text color={brandStars}>*</Text>
              </FormLabel>
              <InputGroup size="md">
                <Input
                  isRequired={true}
                  fontSize="sm"
                  placeholder="Min. 8 characters"
                  mb="24px"
                  size="lg"
                  type={show ? 'text' : 'password'}
                  variant="auth"
                  name="password"
                />
                <InputRightElement display="flex" alignItems="center" mt="4px">
                  <Icon
                    color={textColorSecondary}
                    _hover={{ cursor: 'pointer' }}
                    as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                    onClick={handleClick}
                  />
                </InputRightElement>
              </InputGroup>
              {/* <Flex justifyContent='space-between' align='center' mb='24px'>
              <FormControl display='flex' alignItems='center'>
                <Checkbox
                  id='remember-login'
                  colorScheme='brandScheme'
                  me='10px'
                />
                <FormLabel
                  htmlFor='remember-login'
                  mb='0'
                  fontWeight='normal'
                  color={textColor}
                  fontSize='sm'>
                  Keep me logged in
                </FormLabel>
              </FormControl>
              <NavLink to='/auth/forgot-password'>
                <Text
                  color={textColorBrand}
                  fontSize='sm'
                  w='124px'
                  fontWeight='500'>
                  Forgot password?
                </Text>
              </NavLink>
            </Flex> */}
              <Button
                fontSize="sm"
                backgroundColor={'#3B8F4F'}
                variant="brand"
                fontWeight="500"
                w="100%"
                color="white"
                h="50"
                type="submit"
                mb="24px"
              >
                Sign In
              </Button>
            </FormControl>
          </form>{' '}
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
